<template>
  <div class="form__main">
    <ContactsTable
      ref="table"
      :outerFilters="outerFilters"
      hideControls
      editable
      hideSearch
      insideCampaign
      :campaignId="campaignId"
      :showSelect="isVectorRecruiting"
      :insideModal="isModal"
      :teamFilterOff="teamFilterOff"
      v-model="selectedContacts"
    />
  </div>
</template>

<script>
import ContactsTable from '@/views/contacts/components/ContactsTable';

export default {
  name: 'GroupContacts',
  components: {
    ContactsTable,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Object,
      default: () => ({}),
    },
    isModal: Boolean,
    teamFilterOff: Boolean,
    additionalFilters: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    reload() {
      if (this.$refs.table) {
        this.$refs.table.selected = [];
        this.$refs.table.showSelected = false;
        this.$refs.table.forceReload();
      }
    },
  },
  computed: {
    campaignId() {
      return this.$route?.params?.campaignId || '';
    },
    outerFilters() {
      return {
        ...this.group.filters,
        ...this.additionalFilters,
      };
    },
    selectedContacts: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
